/**
 * @Author: v_jppjpeng
 * @Date: 2024-07-31 09:24:25
 * @Explain: webhook
 */
import http from '../http';
import { WebhookFormData } from './data.d';

const MODEL = '/web_hook';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: WebhookFormData) {
    return http.post(`${MODEL}/add`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 编辑
  onEdit(data: WebhookFormData) {
    return http.post(`${MODEL}/edit`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 发送测试
  onSendTest(data: Record<any, any>) {
    return http.post(`${MODEL}/test_event`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 重置key
  onResetKey(data: Record<any, any>) {
    return http.post(`${MODEL}/reset_key`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
